export const goTo = (url) => {
    window.open(url);
};
export const onCardClick = (name, currentTool, url) => {
    if (name !== currentTool)
        goTo(url);
};
